/* istanbul ignore file */
import React from 'react'

import { Amex } from './amex'
import { Applepay } from './applepay'
import { Bank } from './bank'
import { Cashapp } from './cashapp'
import { Mastercard } from './mastercard'
import { Visa } from './visa'

type ArcadeCardComponent = React.ComponentType

export const EagerArcadeCards: Record<string, ArcadeCardComponent> = {
  Amex,
  Applepay,
  Bank,
  Cashapp,
  Mastercard,
  Visa,
}

export const LazyArcadeCards: Record<string, ArcadeCardComponent> = {
  Cirrus: React.lazy(async () => import('./cirrus').then((m) => ({ default: m.Cirrus }))),
  Dinersclub: React.lazy(async () => import('./dinersclub').then((m) => ({ default: m.Dinersclub }))),
  Discover: React.lazy(async () => import('./discover').then((m) => ({ default: m.Discover }))),
  Jcb: React.lazy(async () => import('./jcb').then((m) => ({ default: m.Jcb }))),
  Maestro: React.lazy(async () => import('./maestro').then((m) => ({ default: m.Maestro }))),
  Unionpay: React.lazy(async () => import('./unionpay').then((m) => ({ default: m.Unionpay }))),
}
